export default __webpack_public_path__ + "static/media/MPE.9d6b7a0c.png";